/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import React, { FC } from 'react';
import { Styled } from 'components/ITeroTermsConditionsModal';
import { IteroProposalClient } from 'types';
import { useI18n } from 'contexts/i18n';

interface StandardOrderDetailsTableEMEAProps {
  currentProposal: IteroProposalClient;
  isServiceTermHideRequired: boolean;
}

const StandardOrderDetailsTableEMEA: FC<StandardOrderDetailsTableEMEAProps> = ({
  currentProposal,
  isServiceTermHideRequired,
}) => {
  const i18n = useI18n();
  return (
    <Styled.Table>
      <thead>
        <tr>
          <Styled.Th>{i18n['Product(s)']}</Styled.Th>
          <Styled.Th>{i18n['Quantity']}</Styled.Th>
          <Styled.Th>{i18n['List Price']}</Styled.Th>
          <Styled.Th>{i18n['Promotions/Discounts']}</Styled.Th>
          <Styled.Th>{i18n['Total']}</Styled.Th>
        </tr>
      </thead>
      <tbody>
        {currentProposal?.lineitems.map(item => (
          <React.Fragment key={item.name}>
            <tr>
              <Styled.Td>
                <div>{item.name}</div>
                {item.softwareType && (
                  <>
                    <br />
                    <div>
                      <strong>{i18n['Software Type']}</strong>{' '}
                      {item.softwareType}
                    </div>
                  </>
                )}
                {item.serviceTerm && !isServiceTermHideRequired && (
                  <div>
                    <strong>{i18n['Service Term']}</strong>: {item.serviceTerm}
                  </div>
                )}
              </Styled.Td>
              <Styled.Td>{item.quantity}</Styled.Td>
              <Styled.Td>{item.displayItemUnitPrice}</Styled.Td>
              <Styled.Td>
                {item.promotion?.amount}{' '}
                <div style={{ letterSpacing: '0.1px' }}>
                  {item.promotion?.programName}
                  {item.promotion?.programCode &&
                    `(${item.promotion?.programCode})`}
                </div>
              </Styled.Td>
              <Styled.Td>{item.displayItemTotal}</Styled.Td>
            </tr>

            {item?.options?.map(option => (
              <tr key={option.name}>
                <Styled.Td>{option.name}</Styled.Td>
                <Styled.Td>{option.quantity}</Styled.Td>
                <Styled.Td>{option.displayItemUnitPrice}</Styled.Td>
                <Styled.Td></Styled.Td>
                <Styled.Td>{option.displayItemTotal}</Styled.Td>
              </tr>
            ))}
          </React.Fragment>
        ))}
        <Styled.TotalTr>
          <Styled.Td>
            {i18n['Total Net Price']}
            <br />({i18n['Exclusive of taxes']})
          </Styled.Td>
          <Styled.Td></Styled.Td>
          <Styled.Td>{currentProposal.displayTotal}</Styled.Td>
          <Styled.Td>{currentProposal.displayAdjustmentTotal}</Styled.Td>
          <Styled.Td>{currentProposal.displayTotalAfterAdjustments}</Styled.Td>
        </Styled.TotalTr>
      </tbody>
    </Styled.Table>
  );
};

export default StandardOrderDetailsTableEMEA;
